import React from 'react';
import './App.css';
import { Routes, Route, Link } from 'react-router-dom';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import AboutMe from "./Aboutme"
import Resume from "./Resume"
import MyWebApps from "./MyWebApps"
import Links from "./Links"
import profileImg from "./resource/me.jpg"

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import ArticleIcon from '@mui/icons-material/Article';
import AppsIcon from '@mui/icons-material/Apps';
import LinkIcon from '@mui/icons-material/Link';
import GitHubIcon from '@mui/icons-material/GitHub';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

function App() {
  const [darkMode, setDarkMode] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);

  const darkTheme = createTheme({
    palette: {
      mode: darkMode? 'dark': 'light',
    },
  });

  React.useEffect(() => {
    const handleResize = () => {
        if (window.innerWidth < 800) {
          setCollapsed(true);
        } else {
          setCollapsed(false);
        }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);  //experimenting

    return () => {
        window.removeEventListener("resize", handleResize);
        window.removeEventListener("load", handleResize);
    };
}, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div style={{display:"flex", height:"100%", minHeight:"100vh"}}>
        <Sidebar collapsed ={collapsed} >
        <img src={profileImg} style={{width: !collapsed?"150px":"50px",display:"block", clipPath:"circle()", margin:"auto", marginTop:"20px"}} />
        <Menu>
            <MenuItem className="menutitle"
            icon = {<MenuIcon />}
            onClick={() => setCollapsed(!collapsed)}
            >
              <h2>Huo Chen</h2>

            </MenuItem>
            <Link to ="/" className="menuitem"><MenuItem icon = {<PersonIcon />} >About Me</MenuItem></Link>
            <Link to ="/resume" className="menuitem"><MenuItem icon = {<ArticleIcon />} >Brief Resume</MenuItem></Link>
            <Link to ="/mywebapps" className="menuitem"><MenuItem icon = {<AppsIcon />} >My Web Apps</MenuItem></Link>
            <Link to ="/links" className="menuitem"><MenuItem icon = {<LinkIcon />} >Links</MenuItem></Link>
            <Link to ="https://github.com/huoatwork" className="menuitem"><MenuItem icon = {<GitHubIcon />} >My Github</MenuItem></Link>
        </Menu>
        </Sidebar>
        <div style={{margin:"20px",flexGrow:"1"}}>
          <div style={{width:"100%",textAlign:"right"}}><FormControlLabel control={<Switch checked={darkMode} onChange={()=>{setDarkMode(!darkMode)}} />} label="Dark Mode" labelPlacement="start" /></div>
          <Routes>
            <Route path="/" element = {<AboutMe />} />
            <Route path="/resume" element = {<Resume />} />
            <Route path="/mywebapps" element = {<MyWebApps />} />
            <Route path="/links" element = {<Links />} />
          </Routes>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;